export function getRequiredFilter(
  search: string,
  appSettings,
): string | undefined {
  return undefined;
}
